import React, { useState } from 'react';
import appStoreLogo from '../../assets/home/appStoreLogo.svg';
import googlePlayLogo from '../../assets/home/googlePlayLogo.png';
import { Modal, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';


export const AppsButtonContainer = ({ isColumn = '' }) => {
    const { lang } = useParams(); // Get 'lang' from the URL
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            <div className={`d-inline-flex ${isColumn} align-items-center`}>
                {/* <a target="_blank" rel="noopener noreferrer" href="https://testflight.apple.com/join/8kvxgTrb">
                    <img className='app-button-app-store' src={appStoreLogo} style={{ height: '40px' }} alt="App Store" />
                </a> */}
                <Link to={`/${lang}/iOSInvitation`}>
                    <img className='app-button-app-store' src={appStoreLogo} style={{ height: '40px' }} alt="App Store" />
                </Link>
                <a target="_blank" rel="noopener noreferrer" href="https://play.google.com/store/apps/details?id=de.netzlab.findtogether">
                    <img className='app-button-google-play' src={googlePlayLogo} style={{ height: '57px', width: '143px' }} alt="Google Play" />
                </a>
            </div>

            {/* Bootstrap Modal for "App Coming Soon" */}
            <Modal show={show} onHide={handleClose} className='mt-5'>
                <Modal.Header closeButton>
                    <Modal.Title>App Coming Soon</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Our app is not available yet. Stay tuned, it’s coming soon!
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

